import { render, staticRenderFns } from "./table-page.vue?vue&type=template&id=0f6e671b&scoped=true"
import script from "./table-page.vue?vue&type=script&lang=js"
export * from "./table-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_cache-loader@4.1.0_webpack@4.47.0__css-load_26f79dc07a063b5c44cf61f12066c2ef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6e671b",
  null
  
)

export default component.exports